import namelize from '@formatters/namelize';

export function user(object) {
  object.label = namelize(object.name);
  object.value = object.id;

  return object;
}

export function vehicle(object) {
  object.label = `${object.vehicle_brand?.name || object.brand} - ${object.name || object.model_name}`;
  object.value = `${object.vehicle_brand?.name || object.brand} - ${object.name || object.model_name}`;

  return object;
}
